module.exports = __webpack_public_path__ + "static/scale-model-of-patterson-house-in-hayward-california-3bfa4f6090d56647d0f5e6690239f4d8.png";